import { isEmpty } from "@utils/var.check";
import { GAME_CHOICE_TYPE } from "@modules/editor/service/gamification.constant";
import { DIGITAL_BADGE_GAME_AWARD_TYPE } from "@modules/manage-digital-badge/service/digital.badge.constant";

export default {
  data() {
    return {
      gameChoiceList: [],
    };
  },
  computed: {
    isAchievement() {
      return this.gameAward.type === "ACHIEVEMENT";
    },
    isGameAvatar() {
      return this.gameAward.type === "GAME_AVATAR";
    },
    isCollectible() {
      return this.isAchievement || this.isGameAvatar || this.isDigitalBadge;
    },
    isDigitalBadge() {
      return this.gameAward.type === DIGITAL_BADGE_GAME_AWARD_TYPE.DIGITAL_BADGE;
    },
    gameAwardExist() {
      return this.gameAward.canBeFound === true;
    },
    hasChoice() {
      return !isEmpty(this.gameChoiceList);
    },
    isTextInputChoice() {
      return this.hasChoice && this.gameAward.choiceType === GAME_CHOICE_TYPE.TEXT_INPUT;
    },
    showDropDownOrTextChoices() {
      return (
        this.isTextInputChoice ||
        (this.hasChoice &&
          (this.gameChoiceList.length >= 3 ||
            this.gameChoiceList.some((choice) => choice.choices.length > 25)))
      );
    },
    isHideImage() {
      return this.gameAward.hideImage;
    },
  },
};
